// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__1HfJ-","link":"Navbar_link__2coYz","home":"Navbar_home__FIXkT","act":"Navbar_act__2R3Ea","logoImg":"Navbar_logoImg__2MO0z"};